import { Injectable, signal } from '@angular/core';
import { appVersion } from '../../../environments/version';

@Injectable({ providedIn: 'root' })
export class VersionService {
  readonly clientVersion = appVersion;
  readonly isMismatch = signal(false);
  readonly serverVersion = signal<string | null>(null);

  setMismatch(serverVersion: string): void {
    this.serverVersion.set(serverVersion);
    this.isMismatch.set(true);
  }
}
